module.exports = __webpack_public_path__ + "img/coinph.582c54f8.png";